import { useCallback } from 'react';
import { useConfig } from 'wagmi';

import type { Chains, WalletAdapterData } from '../../../types';
import { connectEagerly } from '../../../utils';

export const useEagerConnect = (wallets: WalletAdapterData[], chains: Chains) => {
  const config = useConfig();

  const eagerConnect = useCallback(() => {
    const autoConnectOnlyAdapters = wallets.filter(({ autoConnectOnly }) => autoConnectOnly);

    return connectEagerly(config, autoConnectOnlyAdapters, chains);
  }, [wallets, chains, config]);

  return { eagerConnect };
};
